import { Injectable } from "@angular/core";
import { Cita } from "../models";
import { databases, ID, storage } from "../config/appwrite";
import { environment } from "src/environments/environment";
import { Query } from "appwrite";

@Injectable({
  providedIn: "root",
})
export class CitaService {
  private collectionId = "citas";
  private collectionHistorico = "citas_historico";
  private DATABASE_NAME = environment.databaseName;

  constructor() {}

  //VALIDACIÓN SI UNA CITA EXISTE
  // SE BUSCA POR:
  // ID ESPECIALISTA
  // FECHA CITA
  // ID ESTADO CITA: cancelada, reprogramada
  getCitasAndValidate(idEspecialista: string, fechaCita: string) {
    return databases
      .listDocuments<Cita>(this.DATABASE_NAME, this.collectionId, [
        Query.equal("idEspecialista", idEspecialista),
        Query.equal("fechaCita", fechaCita),
        Query.notEqual("idEstadoCita", "cancelada"),
        Query.notEqual("idEstadoCita", "reprogramada"),
      ])
      .then((response) => response.documents);
  }

  // CREA UNA NUEVA CITA
  createDocument(data: Cita) {
    return databases.createDocument(
      this.DATABASE_NAME,
      this.collectionId,
      ID.unique(),
      data
    );
  }

  // OBTIENE DE CITAS DE UN ESPECIALISTA
  getDocumentsByEspecialistagreaterThanCurrentDate(
    idEspecialista: string,
    dateRange: { start: Date; end: Date }
  ): Promise<Cita[]> {
    // Extraemos start y end del objeto dateRange
    const { start, end } = dateRange;

    // Convertimos las fechas a ISO string
    const startISO = start.toISOString();
    const endISO = end.toISOString();

    return databases
      .listDocuments<Cita>(
        this.DATABASE_NAME,
        this.collectionId, //citas
        [
          Query.equal("idEspecialista", idEspecialista),
          Query.greaterThanEqual("fechaCita", startISO),
          Query.lessThan("fechaCita", endISO),
          Query.notEqual("idEstadoCita", "reprogramada"),
          Query.notEqual("idEstadoCita", "cancelada"),
          Query.select(["fechaCita", "duracionCita", "idEstadoCita.$id"]),
        ]
      )
      .then((response) => response.documents);
  }

  // LISTADO DE CITAS DESDE EL DIA DE HOY
  getDocumentsThanCurrentDate(): Promise<Cita[]> {
    let firstDate = new Date();
    firstDate.setHours(0, 0, 0, 0);
    return databases
      .listDocuments<Cita>(this.DATABASE_NAME, this.collectionId, [
        Query.greaterThanEqual("fechaCita", firstDate.toISOString()),
      ])
      .then((response) => response.documents);
  }

  // Este metodo se encarga de obtener las citas de un paciente excluyendo las que se encuentren como cerrada, terminada o reprogramada
  getDocumentsbyPaciente(idPaciente: string): Promise<Cita[]> {
    return databases
      .listDocuments<Cita>(
        this.DATABASE_NAME,
        this.collectionId, //citas
        [
          Query.equal("idPaciente", idPaciente),
          Query.orderDesc("fechaCita"),
          Query.notEqual("idEstadoCita", "cancelada"),
          Query.or([
            Query.notEqual("idEstadoCita", "cerrada"),
            Query.notEqual("IdEstadoPago", "aprobada"),
          ]),
        ]
      )
      .then((response) => response.documents);
  }

  // OBTENE LAS CITAS DE UN PACIENTE, EXCLUYENDO LAS CERRADAS, TERMINADAS O REPROGRAMADAS
  getDocumentsbyPaciente2(idPaciente: string) {
    /*  TODO: REVISAR QUE ESTA OCURRIENDO CON LAS CONSULTAS 
        Se crea este método 2 para validar 
    */

    return databases.listDocuments<any>(
      this.DATABASE_NAME,
      this.collectionId, //citas
      [
        Query.equal("idPaciente", idPaciente),
        Query.orderDesc("fechaCita"),
        Query.notEqual("idEstadoCita", "cancelada"),
        Query.select(["$id", "fechaCita", "idEspecialista.banco"]),

        Query.limit(1),
      ]
    );
  }

  //TRAE LA ÚLTIMA CITA DEL PACIENTE PARA OBTENER EL ESPECIALISTA QUE LO ATENDIO.
  getLastCita(idPaciente: string): Promise<Cita | null> {
    let firstDate = new Date();
    firstDate.setHours(0, 0, 0, 0);
    return databases
      .listDocuments<Cita>(this.DATABASE_NAME, this.collectionId, [
        Query.equal("idPaciente", idPaciente),
        Query.orderDesc("fechaCita"),
        Query.limit(1), // Limita el resultado a 1 documento
        Query.select(["idEspecialista.$id", "idEspecialista.nombre"]),
      ])
      .then((response) => response.documents[0] || null);
  }

  //  OBTIENE DE CITAS DE UN ESPECIALISTA
  getDocumentsByEspecialista(idEspecialista: string): Promise<Cita[]> {
    return databases
      .listDocuments<Cita>(this.DATABASE_NAME, this.collectionId, [
        Query.equal("idEspecialista", idEspecialista),
      ])
      .then((response) => response.documents);
  }

  // OBTIENE UNA CITA POR ID
  getDocument(idDocument: string) {
    return databases.getDocument(
      this.DATABASE_NAME,
      this.collectionId,
      idDocument
    );
  }

  //LISTADO DE CITAS
  getDocuments(): Promise<Cita[]> {
    return databases
      .listDocuments<Cita>(this.DATABASE_NAME, this.collectionId)
      .then((response) => response.documents);
  }

  // CAMBIA ESTADO DE UNA CITA
  changeEstadoCita(item: any) {
    return databases.updateDocument(
      this.DATABASE_NAME,
      this.collectionId,
      item.$id,
      item
    );
  }

  

  // ACTUALIZA UNA CITA
  updateDocument(idCita: string, data: any) {
    data.$databaseId = undefined;
    data.$collectionId = undefined;
    return databases.updateDocument(
      this.DATABASE_NAME,
      this.collectionId,
      idCita,
      data
    );
  }



  // ####################################################################
  // CITAS HISTORICO

  getCitasByPacienteHistorico(idPaciente: string): Promise<any[]> {
    return databases
      .listDocuments(this.DATABASE_NAME, this.collectionHistorico, [
        Query.equal("idPaciente", idPaciente),
        Query.notEqual("idEstadoCita", "cancelada"),
        Query.orderDesc("fechaCita"),
        Query.select(["idCita.$id", "fechaCita", "idEstadoCita.$id"]),
      ])
      .then((response) => response.documents);
  }

  /**
   *
   * @param idPaciente
   * @returns
   */
  getCitasTerminadas(idPaciente: string): Promise<Cita[]> {
    return databases
      .listDocuments<Cita>(this.DATABASE_NAME, this.collectionId, [
        Query.orderDesc('$createdAt'),
        Query.or([
          Query.equal('idEstadoCita', 'terminada'),
          Query.equal('idEstadoCita', 'cerrada'),
        ]),

        Query.equal('idPaciente', idPaciente),
        Query.limit(1),
      ])
      .then((response) => response.documents);
  }

  /**
   *
   * @param idCita
   * @returns
   */
  getLastCitaHistorico(idCita: string): Promise<Cita[]> {
    return databases
      .listDocuments<Cita>(this.DATABASE_NAME, this.collectionHistorico, [
        Query.orderDesc('$createdAt'),
        Query.equal('idCita', idCita),
        Query.limit(1),
      ])
      .then((response) => response.documents);
  }
}
